<template>
  <section
    class="intro"
    :class="siteVariant"
  >
    <div class="wrapper">
      <div class="inner-box">
        <p class="first-paragraph">
          Are you a Pro at Storytelling?
        </p>
        <p class="second-paragraph">
          It's Your Time to Shine!
        </p>
      </div>
      <ul v-html="variables[siteVariant].storytellerIntroText" />
    </div>
  </section>
</template>

<script setup>
defineProps({
  siteVariant: String,
});

const variables = {
  acura: {
    storytellerIntroText: `
      <li>Top performers stand out by demonstrating how the ADX A-Spec Advance elevates the client experience.</li>
      <li>Win cash, prizes, and a trip to Las Vegas!</li>
      <li>Grab a camera, team up with a colleague, and show us how you create stories through your video!</li>
    `,
  },
  honda: {
    storytellerIntroText: `
      <li>Top performers stand out by demonstrating how the Passport TrailSport Elite elevates the customer experience.</li>
      <li>Win cash, prizes, and a trip to Las Vegas!</li>
      <li>Grab a camera, team up with a colleague, and show us how you create stories through your video!</li>
    `,
  },
};
</script>

<style lang="scss" scoped>
.intro {
  position: relative;
  text-align: left;
  background: url('@/assets/img/intro-bg.webp');
  background-size: auto 80%;
  background-position: bottom;
  background-repeat: no-repeat;
  padding: 0 40px;
  padding-top: 28px;
  height: clamp(540px, 840px, 88vw);

  @media (min-width: 641px) {
    background-size: auto 100%;
    padding-top: 50px;
  }

  @media (min-width: 1025px) {
    padding-top: 75px;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient( rgb(3, 6, 27, 1), rgb(3, 6, 27), rgba(3, 6, 27, 0.1));
    z-index: -1;
  }

  .wrapper {
    width: 100%;
    max-width: 1640px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 34px;

    @media (min-width: 1025px) {
      flex-direction: row;
      align-items: flex-start;
      gap: 50px;
    }

    @media (min-width: 1441px) {
      gap: 96px;
    }
  }

  .inner-box {
    color: $AC_White;
    padding: 4px 0 8px 10px;
    border-left: 2px solid $AC_Orange;

    @media (min-width: 1025px) {
      flex: 1 1 760px;
      padding: 20px 0 10px 25px;
      border-width: 5px;
    }
  }

  .first-paragraph {
    font-size: clamp(11px, 29px, 2vw);
    letter-spacing: 0.5px;
    margin-bottom: 7px;

    @media (min-width: 1025px) {
      margin-bottom: 15px;
    }
  }

  .second-paragraph {
    font-size: clamp(26px, 66px, 3.5vw);
    font-weight: 300;
    line-height: 1.2;
    letter-spacing: 1px;
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 20px;
    font-size: clamp(14px, 28px, 2.15vw);
    color: $AC_White;
    line-height: 1.5;
    max-width: 680px;

    @media (min-width: 1025px) {
      max-width: none;
      flex: 1 1 835px;
    }

    @media (min-width: 1600px) {
      padding-right: 165px;
    }
  }
}

.intro.honda {
  .first-paragraph {
    font-weight: 700;
  }
}

.intro.acura {
  ul {
    font-family: 'Avenir Book';
    font-weight: normal;
  }
}
</style>
